import { useGoalSubgoalProgress as _useGoalSubgoalProgress } from '@griply/hooks';
import { Goal, Timestamp } from '@griply/types';
import { useSubGoals } from 'features/goals';
import { useTasks } from 'features/tasks';
import { useEntityLinks } from 'shared/hooks/use-entity-links';

export type UseGoalSubgoalProgressOptions = {
  startDate: Timestamp;
  endDate: Timestamp;
};

export const useGoalSubgoalProgress = (
  goal: Goal,
  { startDate, endDate }: UseGoalSubgoalProgressOptions,
) => {
  const subGoals = useSubGoals(goal.id, true);
  const allTasks = useTasks(
    { goals: [goal.id, ...subGoals.map(({ id }) => id)] },
    !!goal.id,
  );
  const links = useEntityLinks();

  return _useGoalSubgoalProgress(goal, {
    startDate,
    endDate,
    subGoals,
    allTasks,
    links,
  });
};
